import BaseValidator from '../lib/data/Validations/BaseValidator'

export default {
  name    : 'formData',
  data () {
    return {
      isSaving           : false,
      formValid          : false,
      form_data          : null,
      validator          : null,
      showGenericError   : false,
      serverErrorMessages: {},
      model              : {}
    }
  },
  props   : {},
  watch   : {},
  methods : {
    formValidate () {
      this.formValid = true
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      if (this.$refs.form) this.formValid = this.formValid && this.$refs.form.validate()
      if (this.validator) this.formValid = this.formValid && this.validator.validate()
      return this.formValid
    },

    handleFormSaveResponse (response) {
      if (response.data.status === 'success') {
        if (response.data.data === true) {
          this.formSaveSuccess()
        } else {
          this.formSaveError(response.data)
          this.showGenericError = true
        }
      } else {
        this.setServerErrorMessages(response.data.data)
      }
    },

    formSaveSuccess () {
      if (this.$refs.form) this.formInit()
      this.$emit('saveSuccess')
    },

    formSaveError (error) {
      this.$emit('saveError', error)
    },

    formInit () {
      if (this.$refs.form) {
        this.editItem = {}
        this.validator = new BaseValidator()
        this.$nextTick(() => {
          this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.editItem = JSON.parse(JSON.stringify(this.model || {}))
          this.validator = new BaseValidator(this.editItem, this.validationRules, this.validationErrorMessages)
          if (this.$refs.formContainer) this.$refs.formContainer.scrollTop = 0
        })
        if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      }
    },

    setServerErrorMessages (messages) {
      let key
      for (key in messages) {
        if (messages.hasOwnProperty(key)) {
          this.$set(this.serverErrorMessages, key, messages[key])
        }
      }
      this.formSaveError(messages)
    },

    clearServerErrorMessages () {
      this.showGenericError = false
      let key, tmpMessages = {}
      for (key in this.serverErrorMessages) {
        if (this.serverErrorMessages.hasOwnProperty(key)) tmpMessages[key] = []
      }
      this.serverErrorMessages = JSON.parse(JSON.stringify(tmpMessages))
    },
  },
  computed: {
    editItem: {
      get () {
        return this.form_data
      },
      set (val) {
        this.form_data = val
      }
    }
  },
}
